import { SubmitButton } from 'components/common/buttons/SubmitButton';
import PdfForm from 'components/Pdf/PdfForm';
import jsPDF from 'jspdf';
import React, { useEffect, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchGeneratedInvoices, invoicesSelector } from 'slices/invoiceSlice';

const AllPdfView = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();
    const invoiceRef = useRef(null);
    const [buttonLoader, setButtonLoader] = useState(false);

    const { generatedInvoices, loader } = useSelector(invoicesSelector);
    const generatedInvoice = generatedInvoices?.find(t => t.id === Number(id));
    const invoiceNumber = generatedInvoice?.invoice_number;

    useEffect(() => {
        dispatch(fetchGeneratedInvoices());
    }, [dispatch]);


    const handleGeneratePdf = () => {
        if (!invoiceNumber) {
            toast.error("Invoice number not found!", {
                className: "errorToast",
            });
            return;
        }

        setButtonLoader(true);
        const doc = new jsPDF('p', 'pt', 'a4');

        doc.html(invoiceRef.current, {
            callback: function (doc) {
                doc.save(`${invoiceNumber}.pdf`);
                toast.success("Invoice downloaded successfully!", {
                    className: "successToast",
                });
                setButtonLoader(false);
            },
            margin: [7, 7, 7, 7],
            x: 7,
            y: 7,
            autoPaging: 'text',
            html2canvas: {
                scale: 0.73,
                useCORS: true,
            },
        });
    };
    return (
        <div className="content">
            <div className='row_savebtn'>
                <div className='d-flex align-items-center gap-2'>
                    <button className="main_heading back_button" onClick={() => navigate(-1)}>
                        <i className="fa-solid fa-arrow-left"></i> Back
                    </button>
                </div>
                <SubmitButton
                    handleSubmit={handleGeneratePdf}
                    buttonType={'button'}
                    loader={buttonLoader}
                    btnText={'Download Invoice'}
                />
            </div>
            <div ref={invoiceRef} className='view_pdf_main'>
                <PdfForm data={generatedInvoice} loader={loader} type={generatedInvoice?.invoice_type}/>
            </div>
        </div>
    );
};

export default AllPdfView;
